import { render, staticRenderFns } from "./DrawerFamilyClaimsTab.vue?vue&type=template&id=51c5384d&scoped=true"
import script from "./DrawerFamilyClaimsTab.vue?vue&type=script&lang=js"
export * from "./DrawerFamilyClaimsTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerFamilyClaimsTab.vue?vue&type=style&index=0&id=51c5384d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c5384d",
  null
  
)

export default component.exports